<template>
  <div class="d-flex flex-column flex-root">
    <!-- begin:: Header Mobile -->
    <vue-confirm-dialog></vue-confirm-dialog>
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->
    <Loader v-if="isLoading" v-bind:logo="loaderLogo"></Loader>

    <div class="d-flex flex-row flex-column-fluid page">
      <!--begin::Aside-->
      <KTAside></KTAside>
      <!--end::Aside-->

      <div class="d-flex flex-column flex-row-fluid wrapper" id="kt_wrapper">
        <!--begin::Header-->
        <KTHeader></KTHeader>
        <!--end::Header-->
        <!--begin::Content-->
        <div class="content  d-flex flex-column flex-column-fluid" id="kt_content">
          <!--begin::Subheader-->
          <KTSubheader v-bind:breadcrumbs="breadcrumbs" v-bind:title="pageTitle" />
          <!--end::Subheader-->

          <div class="d-flex flex-column-fluid">
            <div class="container">
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>

          </div>
        </div>
        <!--end::Content-->
        <!--begin::Footer-->
        <KTFooter></KTFooter>
        <!--end::Footer-->
        <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar>
        <KTScrollTop></KTScrollTop>
      </div>
      <v-col cols="auto">
        <v-dialog persistent v-model="modalfilial" transition="dialog-bottom-transition" max-width="600">
          <template>
            <v-card>
              <v-card>
                <h2 class="pt-3 pl-3 pb-2">
                  Entre em uma filial para continuar
                </h2>
                <button class="btn btn-icon btn-hover-light-primary position-absolute right-0 top-0 mt-3 mr-8"
                  @click="logout">
                  <i class="fas fa-sign-out-alt"></i>
                </button>
              </v-card>
              <v-text-field v-model="filtroFilial" label="Digite o nome da filial" class="mx-4 my-2 mt-5" clearable
                dense outlined></v-text-field>
              <v-data-table :headers="[
                { text: 'Filial', value: 'filial' },
                { text: '', value: 'acao', sortable: false },
              ]" :items="lista_filiais_autorizadas" :items-per-page="10" class="elevation-1" :footer-props="{
                'items-per-page-text': 'Linhas por página',
                'items-per-page-options': [5, 10, 20, 50, 100],
              }" :no-data-text="'Nenhuma filial autorizada para seu perfil. Contate o administrador.'">
                <template #item.acao="{ item }">
                  <div class="text-right w-100">
                    <v-btn icon small color="primary" @click="selectFilial(item.id)">
                      <inline-svg src="media/svg/icons/Navigation/Arrow-right.svg"></inline-svg>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn text @click="logout">Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HtmlClass from "@/core/services/htmlclass.service";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile";
import Loader from "@/view/layout/content/Loader";
import KTHeader from "@/view/layout/header/Header";
import KTSubheader from "@/view/layout/subheader/Subheader";
import KTFooter from "@/view/layout/footer/Footer";
import KTStickyToolbar from "@/view/layout/extras/StickyToolbar.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/store/htmlclass.module.js";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeaderMobile,
    Loader,
    KTHeader,
    KTFooter,
    KTSubheader,
    KTStickyToolbar,
    KTScrollTop
  },
  data: function () {
    return {
      fullPage: true,
      container: this.$refs.loadingContainer,
      canCancel: true, // default false
      onCancel: this.yourCallbackMethod,
      color: "#7a0000",
      useSlot: true,
      loader: "spinner",
      height: 60,
      width: 60,
      backgroundColor: "#110f38",
      opacity: 0.9,
      modalfilial: false,
      filtroFilial: "",

    };
  },
  created() {
    this.setFilialGuardada()
    // console.log('estou aqui')

  },
  methods: {
    logout() {
      this.$router.push({ name: 'login' })
      this.$store.dispatch('auth/logout')
    },
    hideModalFilial() {
      this.modalfilial = false;
    },
    async selectFilial(filialId) {
      await this.$store.dispatch("sistema/setFilial", filialId);
      await this.$store.dispatch("sistema/listar_permissoes_sede", filialId);
      this.hideModalFilial()
      window.location.reload();
    },
    async setFilialGuardada() {
      await this.$store.dispatch("sistema/setFilialGuardada");

      if (this.$store.state.sistema.lista_permissoes_filial == "") {
        await this.$store.dispatch("sistema/listar_filiais_autorizadas");

        if (this.lista_filiais_autorizadas.length == 1) {
          this.modalfilial = false
          this.selectFilial(this.lista_filiais_autorizadas[0].id)
        } else {
          this.modalfilial = true;

        }
      }

      // this.$store.dispatch("evento/listar_eventos");

    },
  },
  beforeMount() {
    // show page loading

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // check if current user is authenticated
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }

    // Simulate the delay page loading
    // setTimeout(() => {
    //   // Remove page loader after some time
    //   this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    // }, 2000);
  },
  computed: {
    lista_filiais_autorizadas() {
      const lista = Object.values(
        this.$store.state.sistema.lista_filiais_autorizadas
      );
      if (!this.filtroFilial) return lista;
      const filtro = this.filtroFilial.toLowerCase();
      return lista.filter(
        (filial) =>
          filial.filial && filial.filial.toLowerCase().includes(filtro)
      );
    },
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    isLoading() {
      return this.$store.state.configEmpresa.isLoading;
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + "media/logos/bt.png";
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

  }
};
</script>

<style scoped></style>
